/**
 * Отступ под кнопку меню внизу экрана (телефон, планшет — `MobileSidebarTrigger`)
 * и высота страницы, которая его учитывает. `pb-20` у `main` плюс страница в
 * `min-h-screen` давали 80 px прокрутки даже у пустой страницы. Менять вместе.
 *
 * Высоты — в `dvh`, а не `vh`: на телефоне `100vh` — экран БЕЗ панелей браузера,
 * то есть больше видимой области на высоту адресной строки, и любая страница
 * листалась вниз в пустоту. На ПК `dvh` и `vh` совпадают.
 */
export const MOBILE_MENU_PB_CLASS = 'pb-20 lg:pb-0'
export const PAGE_MIN_H_CLASS = 'min-h-[calc(100dvh-5rem)] lg:min-h-dvh'
export const PAGE_H_CLASS = 'h-[calc(100dvh-5rem)] lg:h-dvh'
